export default __webpack_public_path__ + "static/media/IO.e8fff2ec.svg";